/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Heading, IconButton, IconClose } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';
import AdvSaveSearch from './AdvSaveSearch';

const AdvFormHeader = ({
  pageData,
  setPageData,
  toggleAdvFormSearch,
  showSaveSearch,
  savedSearchList,
  showPopup,
  setShowPopup,
  onItemClick,
  handleFormReset,
}) => (

  <div css={advFormStyles['.formRow']} className="col-md-12 pad-0-lr">
    <div className="row margin-0-lr pad-1-t flex-justify-between flex-align-items-center">
      <div className="row margin-0-lr pad-1-t flex-justify-between flex-align-items-center">
        <Heading
          id="AdvFormHeader-formHeader"
          level={2}
          className="dls-gray-06"
          headingStyle="heading5"
        >
          {pageData.formHeader}
        </Heading>
        {showSaveSearch
                && (
                <AdvSaveSearch
                  pageData={pageData}
                  setPageData={setPageData}
                  savedSearchList={savedSearchList}
                  showPopup={showPopup}
                  setShowPopup={setShowPopup}
                  onItemClick={onItemClick}
                  handleFormReset={handleFormReset}
                />
                )}
      </div>

      <IconButton
        id="AdvFormHeader-advSearchClose"
        styleType="tertiary"
        icon={<IconClose />}
        onClick={toggleAdvFormSearch}
      />
    </div>
  </div>
);

AdvFormHeader.displayName = 'AdvFormHeader';

AdvFormHeader.propTypes = {
  pageData: PropTypes.shape({
    formHeader: PropTypes.string,
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
  setPageData: PropTypes.func.isRequired,
  toggleAdvFormSearch: PropTypes.func.isRequired,
  savedSearchList: PropTypes.shape([]),
  showSaveSearch: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired,
  showPopup: PropTypes.bool,
  setShowPopup: PropTypes.func,
  handleFormReset: PropTypes.func,
};

export default AdvFormHeader;
